import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'policyMetaDataJsonArray'
})
export class PolicyMetaDataJsonArrayPipe implements PipeTransform {

  transform(value: string, property: string): any {
    if (!value || !property) {
      return null;
    }

    const parsedValue = JSON.parse(value);
    return parsedValue[property];
  }

}
